import { render } from "./Principal.vue?vue&type=template&id=e0aea2a8&scoped=true"
import script from "./Principal.vue?vue&type=script&lang=js"
export * from "./Principal.vue?vue&type=script&lang=js"

import "./Principal.vue?vue&type=style&index=0&id=e0aea2a8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0aea2a8"]])

export default __exports__